module.exports = __webpack_public_path__ + "static/scale-model-of-cars-land-in-garden-grove-california-128f8a816f69bb352164592a4778c5a8.png";